import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Box, ListItemButton, ListItemIcon, ListItemText, Theme } from "@mui/material";
import { SxProps } from '@mui/system';
import React from "react";
import { INavigationItem } from "../../../services/navigation-data-service/Models";

type MobileGroupListItemProps =  {
    data: INavigationItem,
    open: boolean;
    onToggle: (item: INavigationItem) => Promise<void>;
    onSelected: (item: INavigationItem) => Promise<void>;
    sx?: SxProps<Theme>
};

export function MobileGroupListItem({data, open, onToggle, onSelected, sx}: MobileGroupListItemProps) {
    const onIconClick = async (event: React.MouseEvent<HTMLDivElement, MouseEvent>, item: INavigationItem) => {
        event.persist();        
        event.stopPropagation();
        event.preventDefault();

        await onToggle(item);
    }

    const onItemClick = async (event: React.MouseEvent<HTMLDivElement, MouseEvent>, item: INavigationItem) => {

        event.persist();        
        event.stopPropagation();
        event.preventDefault();

        if (item.allowClick) {
            await onSelected(item);
        }
    }

    return (
        <ListItemButton
            //className={className} 
            sx={sx}
            onClick={(e) => onItemClick(e, data)}
            role='treeitem'
            aria-expanded={open ? 'true' : 'false'}>
            <ListItemText>
                <Box 
                //className={classes.listItem}
                sx={{
                    whiteSpace: 'nowrap',  
                    overflow: 'hidden',  
                    textOverflow: 'ellipsis'
                }}>
                    {data && data.deviceCount ? `${data.title}  [${data.deviceCount?.toString()}]` : data?.title}
                </Box>                            
            </ListItemText>
            {
                data?.hasChildren &&
                <ListItemIcon data-testid={data.objectID} style={{justifyContent: 'flex-end'}} onClick={(e) => onIconClick(e, data)} role='button' aria-label='expand or collapse'>
                    {!open ? <ExpandMore /> : <ExpandLess />}
                </ListItemIcon>
            }
        </ListItemButton>
    );
}

